import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from, mergeMap, Observable } from 'rxjs';

import { URLS } from '@shared/constants';
import {
  CommonResponseDTO,
  IConfigurableFieldConfigResponse,
  IIdentityResponse,
} from '@shared/interfaces';

@Injectable({
  providedIn: 'root',
})
export class IdentitiesInternalService {
  constructor(private http: HttpClient) {}

  getInternalFields() {
    return this.http.get<CommonResponseDTO<IConfigurableFieldConfigResponse[]>>(
      URLS.INTERNAL_IDENTITIES_INTERNAL_FIELDS
    );
  }

  getSingleIdentityFromConnection(
    identityId: string
  ): Observable<CommonResponseDTO<IIdentityResponse>> {
    return this.http.get<CommonResponseDTO<IIdentityResponse>>(
      `${URLS.IDENTITIES}/${identityId}`
    );
  }

  // get only the basic/public information of the user
  getSinglePublicIdentityFromConnection(
    identityId: string
  ): Observable<CommonResponseDTO<IIdentityResponse>> {
    return this.http.get<CommonResponseDTO<IIdentityResponse>>(
      `${URLS.IDENTITIES_PUBLIC}/${identityId}`
    );
  }

  // get only the basic/public information of the users
  getSetOfPublicIdentitiesFromConnection(
    identityIds: string[]
  ): Observable<CommonResponseDTO<IIdentityResponse>> {
    return from(identityIds).pipe(
      mergeMap((identityId) => {
        const url = `${URLS.IDENTITIES_PUBLIC}/${identityId}`;
        return this.http.get<CommonResponseDTO<IIdentityResponse>>(url);
      })
    );
  }
}
